import { css } from 'styled-components';
import token from 'styled-token';
import { StyledButton } from '../../components/Button/Button.styles';
import { StyledIconButton } from '../../components/IconButton/IconButton.styles';
import { StyledLoadingButton } from '../../components/LoadingButton/LoadingButton.styles';
import { StyledTextButton } from '../../components/TextButton/TextButton.styles';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
var directionCSS = function directionCSS(props) {
  var conjoined = props.conjoined,
    direction = props.direction;
  var isColumn = ['column', 'column-reverse'].includes(direction);
  var alignDirection = isColumn || conjoined ? 'stretch' : 'start';
  return css(["align-items:", ";flex-direction:", ";", ",", ",", ",", "{margin-top:", ";margin-left:", ";&:first-child{margin-top:0;margin-left:0;}}"], alignDirection, direction, StyledButton, StyledLoadingButton, StyledTextButton, StyledIconButton, isColumn ? spaceMixin('xs')(props) : 0, !isColumn ? spaceMixin('xs')(props) : 0);
};
var fluidCSS = function fluidCSS(props) {
  return css(["", ",", ",", ",", "{flex-basis:", ";flex-grow:", ";}"], StyledButton, StyledLoadingButton, StyledTextButton, StyledIconButton, props.fluid ? '100%' : 'auto', props.fluid ? '1' : '0');
};
var conjoinedCSS = function conjoinedCSS(props) {
  var conjoined = props.conjoined,
    direction = props.direction;
  if (!conjoined) {
    return '';
  }
  var isColumn = ['column', 'column-reverse'].includes(direction);
  return token({
    marginLeft: 'Button.borderWidth',
    borderRadius: 'Button.borderRadius'
  }, function (_ref) {
    var marginLeft = _ref.marginLeft,
      borderRadius = _ref.borderRadius;
    return css(["position:relative;z-index:1;", ",", ",", ",", "{margin-top:", ";margin-left:", ";border-radius:0;&:first-child{border-top-left-radius:", "px;", "}&:last-child{border-bottom-right-radius:", "px;", "}position:relative;z-index:1;&[aria-pressed='true']{z-index:2;}&:focus{z-index:3;}}"], StyledButton, StyledLoadingButton, StyledTextButton, StyledIconButton, isColumn ? "-" + marginLeft + "px" : 0, !isColumn ? "-" + marginLeft + "px" : 0, borderRadius, isColumn ? css(["border-top-right-radius:", "px;border-bottom-left-radius:0;"], borderRadius) : css(["border-bottom-left-radius:", "px;border-top-right-radius:0;"], borderRadius), borderRadius, isColumn ? css(["border-bottom-left-radius:", "px;border-top-right-radius:0;"], borderRadius) : css(["border-top-right-radius:", "px;border-bottom-left-radius:0;"], borderRadius));
  })(props);
};

/** @class ButtonGroupMixin */
/** @method */
export var ButtonGroupMixin = function ButtonGroupMixin(props) {
  return token('Button.horizontalPadding', function (padding) {
    return css(["display:flex;", "{text-align:center;align-self:stretch;padding-left:", "px;padding-right:", "px;}", " ", " ", " ", ""], StyledTextButton, padding, padding, inlineMediaQueryMixin('direction', directionCSS)(props), inlineMediaQueryMixin('fluid', fluidCSS)(props), inlineMediaQueryMixin('direction', conjoinedCSS)(props), spacingMixin(props));
  })(props);
};